export const editableFieldsList = [];
export const fieldNameDropDown = [];
export const dropDownMenuUrls = [];

export const reportColumnsDefinitions = [
    {
        label: 'Partner',
        field: 'partnerName',
        sign: null,
        width: '100px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
    },
    {
        label: 'Type',
        field: 'type',
        sign: null,
        width: '100px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
    },
    {
        label: 'Date',
        field: 'date',
        sign: null,
        width: '120px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: false,
        canBeFixed: false,
        isMetricValue: true,
        defaultSorting: false,
        isCompareColumn: false,
    },
    {
        label: 'Accounts',
        field: 'countAccounts',
        sign: null,
        width: '100px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    },
    {
        label: 'Account',
        field: 'accountName',
        sign: null,
        width: '100px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'string'
        },
        checked: false,
        visible: true,
        canBeFixed: true,
        isMetricValue: false,
        isCompareColumn: false,
    },
    {
        label: 'Rows',
        field: 'countRows',
        sign: null,
        width: '100px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    },
    {
        label: 'Clicks',
        field: 'countClicks',
        sign: null,
        width: '100px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'integer'
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    },
    {
        label: 'Money',
        field: 'money',
        sign: null,
        width: '100px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    },
    {
        label: 'Bid',
        field: 'bid',
        sign: null,
        width: '100px',
        classes: 'adgroup-column',
        filter: true,
        sort: true,
        format: {
            type: 'float',
            precision: 2
        },
        checked: true,
        visible: true,
        canBeFixed: true,
        isMetricValue: true,
        isCompareColumn: false,
    },
];



// WEBPACK FOOTER //
// ./src/configs/raw-data-partners-report-config.js